import { get, post } from '~/utils/ajax'

export const getMenuStructure = () =>
    get<any>('structure.json?' + Date.now().toString(), undefined, {
        baseUrl: '/static/menu/',
        anonymous: true
    }).then(response => {
        return response
    })
